import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/list';
import { MatButton } from '@angular/material/button';

export interface DialogData {
	title: string;
	message: string;
	htmlContent?: string;
	cancelButtonText: string;
	confirmButtonText: string;
}

@Component({
	selector: 'app-app-dialog-with-buttons',
	templateUrl: './app-dialog-with-buttons.component.html',
	styleUrls: [
		'./app-dialog-with-buttons.component.scss',
		'../../ui/common/main.scss',
	],
	imports: [MatDivider, MatButton, MatDialogClose],
})
export class AppDialogWithButtonsComponent {
	constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
